import { useLoaderData } from 'react-router';

import { useWebsiteTrackingProxy } from '~/modules/tracking/hook/useWebsiteTrackingProxy';
import type { loader } from '~/routes/_app.product.$urlSegment';

/**
 * Click handler for the supplier's own links inside CMS copy.
 *
 * A link the supplier wrote into their description goes out to their site and
 * has to arrive carrying where it came from, the same as the Visit website
 * button beside it. The rewrite happens on the click rather than in the markup
 * because the copy is injected as it was authored, so there is no React
 * element to hand an href to — the handler reads the anchor the reader hit and
 * rewrites it on the way out.
 *
 * The legacy description wired this and the revamp did not, so the buttons the
 * page builds kept their tracking and the copy's own links lost it.
 */
export const useProductLinkTracking = () => {
    const { product } = useLoaderData<typeof loader>();

    return useWebsiteTrackingProxy(
        {
            professionalID: product.Professional.ID,
            professionalTitle: product.Professional.Title,
            itemType: 'Product',
            link: product.Professional.Link,
        },
        {
            attachUTM: true,
            processRelativeURL: true,
        },
    );
};
